export const SELECTED_ADMIN_CLIENT_STORAGE_KEY = 'selectedAdminClientOwnerId';

let actingOwnerId = null;

export function setActingOwnerId(ownerId) {
  const value = ownerId != null && Number(ownerId) > 0 ? String(ownerId) : null;
  actingOwnerId = value;

  try {
    if (value) {
      sessionStorage.setItem(SELECTED_ADMIN_CLIENT_STORAGE_KEY, value);
    } else {
      sessionStorage.removeItem(SELECTED_ADMIN_CLIENT_STORAGE_KEY);
    }
  } catch { }
}

export function getActingOwnerId() {
  if (actingOwnerId) return actingOwnerId;

  try {
    return sessionStorage.getItem(SELECTED_ADMIN_CLIENT_STORAGE_KEY);
  } catch {
    return null;
  }
}
